import { render } from "./FilterPurposeReactive.vue?vue&type=template&id=192f52c8&scoped=true"
import script from "./FilterPurposeReactive.vue?vue&type=script&lang=js"
export * from "./FilterPurposeReactive.vue?vue&type=script&lang=js"

import "./FilterPurposeReactive.vue?vue&type=style&index=0&id=192f52c8&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192f52c8"]])

export default __exports__